import { render, staticRenderFns } from "./Ocular.vue?vue&type=template&id=e4d7852a"
import script from "./Ocular.vue?vue&type=script&lang=js"
export * from "./Ocular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports